import Vue from "vue";
import Vuex from "vuex";
import { AccommodationsModule as accommodations } from "./accommodationsModule";
import { AnalyticsModule as analytics } from "./analyticsModule";
import { AuthModule as auth } from "./authModule";
import { BookingsModule as bookings } from "./bookingsModule";
import { BookingNotesModule as bookingNotes } from "./bookingNotesModule";
import { ConnectionModule as connection } from "./connectionModule";
import { ContactsModule as contacts } from "./contactsModule";
import { GuestNotesModule as guestNotes } from "./guestNotesModule";
import { GuestPastBookingsModule as guestPastBookings } from "./guestPastBookingsModule";
import { ItemsModule as items } from "./itemsModule";
import { ItemTagsModule as itemTags } from "./itemTagsModule";
import { MenusModule as menus } from "./menusModule";
import { MenuTagsModule as menuTags } from "./menuTagsModule";
import { ModifiersModule as modifiers } from "./modifiersModule";
import { NotificationModule as notifications } from "./notificationModule";
import { PackagesModule as packages } from "./packagesModule";
import { PackageTagsModule as packagetags } from "./packageTagsModule";
import { TabsModule as tabs } from "./tabsModule";
import { TagsModule as tags } from "./tagsModule";
import { VendorModule as vendor } from "./vendorModule";
import { TerminalModule as terminal } from "./terminalModule";
import { ImagesModule as images } from "./imagesModule";
import { InvoicesModule as invoices } from "./invoicesModule";
import { InterfaceModule as ui } from "./interfaceModule";
import { paymentMethodsModule as paymentMethods } from "./paymentMethodsModule";
import subscription from "./subscriptionModule";

Vue.use(Vuex);

export const store = new Vuex.Store({
  // strict: true, // strict should be disabled in production!
  modules: {
    accommodations,
    analytics,
    auth,
    bookings,
    bookingNotes,
    connection,
    contacts,
    guestNotes,
    guestPastBookings,
    images,
    invoices,
    items,
    itemTags,
    menus,
    menuTags,
    modifiers,
    notifications,
    packages,
    packagetags,
    paymentMethods,
    subscription,
    tabs,
    tags,
    terminal,
    vendor,
    ui,
  },
});
